/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, utils } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "uint256",
                name: "feeX",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "feeY",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "flashCallback",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
export class IiZiSwapFlashCallback__factory {
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
IiZiSwapFlashCallback__factory.abi = _abi;
